import { IAutoFill as IMarketoAutoFill } from 'marketing-site/lib/marketo/@types/fields'
import { IAutoFill } from 'marketing-site/src/library/elements/Form/@types/AutoFill'

export default function transformAutoFillProp(mktoProp: IMarketoAutoFill): IAutoFill {
  switch (mktoProp.valueFrom) {
    case 'default': // IAutoFillFromValue
      return {
        type: 'value',
        value: mktoProp.value,
      }

    case 'cookie': // IAutoFillFromCookie
      if (!mktoProp.parameterName) throw new Error(`AutoFillFromCookie has empty parameterName`)

      return {
        type: 'cookie',
        cookieName: mktoProp.parameterName,
      }

    case 'query': // IAutoFillFromQueryParam
      if (!mktoProp.parameterName) throw new Error(`AutoFillFromQueryParam has empty parameterName`)

      return {
        type: 'queryParam',
        queryParameterName: mktoProp.parameterName,
      }

    default:
      throw new Error(`Trying to transform unknown AutoFill prop: ${mktoProp.valueFrom}`)
  }
}
